import request from '../request';

/** 添加至购物车 */
export async function addToCart(params: API.UserCartItemBatchOperateReq) {
  return request<API.CommonResponse>({
    url: '/api/mall/rest/cart/item/basic/batchInsert',
    method: 'POST',
    data: params,
  });
}

/** 获取购物车数量 */
export async function getTotalCount() {
  return request<API.CommonResponse<number>>({
    url: '/api/mall/rest/cart/item/biz/getTotalQuantityByPackage',
    method: 'POST',
  });
}

/** 获取购物车列表 */
export async function getCartList() {
  return request<API.CommonResponse<API.PackageCartItemVO[]>>({
    url: '/api/mall/rest/cart/item/biz/listPackage',
    method: 'POST',
    headers: { authLogin: true },
  });
}

/** 修改商品数量 */
export async function updateQuantity(params: API.UserCartItemBatchOperateReq) {
  return request<API.CommonResponse>({
    url: '/api/mall/rest/cart/item/basic/batchUpdateQuantity',
    method: 'POST',
    data: params,
    headers: { authLogin: true },
  });
}

/** 批量删除商品 */
export async function deleteBatchCartItems(
  params: API.UserCartItemBasicBatchDelReq,
) {
  return request<API.CommonResponse>({
    url: '/api/mall/rest/cart/item/basic/delBatchCart',
    method: 'POST',
    data: params,
    headers: { authLogin: true },
  });
}

/** 创建包材意向单 */
export async function createPackageOrder(
  params: API.PackageIntentOrderCreateReq,
) {
  return request<API.CommonResponse>({
    url: '/api/mall/rest/intent/order/create/package',
    method: 'POST',
    data: params,
    headers: { authLogin: true },
  });
}
